import React from "react";
import { GraduationCap, Folder, Folders } from "lucide-react";
import { TFunction } from "i18next";
import { NavigateFunction } from "react-router-dom";
import { CreateOption } from "@components/CreateOptionPickerCst/types";

export type CreatePickerKind = "catalog";

export interface CreatePickerBuildContext {
  navigate: NavigateFunction;
  corporateId: string;
  t: TFunction;
}

export interface CreatePickerDefinition {
  permission: string;
  titleKey: string;
  buildOptions: (ctx: CreatePickerBuildContext) => CreateOption[];
}

export const CREATE_PICKER_REGISTRY: Record<
  CreatePickerKind,
  CreatePickerDefinition
> = {
  catalog: {
    permission: "learning_catalogue.learning_object.write",
    titleKey: "catalog.title",
    buildOptions: ({ navigate, corporateId, t }) => [
      {
        key: "activity",
        icon: <GraduationCap size={32} />,
        title: t("catalog.options.activity.title"),
        description: t("catalog.options.activity.description"),
        onSelect: () =>
          navigate(
            `/v2/corporate/${corporateId}/detail/catalog/activities/add`,
          ),
      },
      {
        key: "course",
        icon: <Folder size={32} />,
        title: t("catalog.options.course.title"),
        description: t("catalog.options.course.description"),
        onSelect: () =>
          navigate(`/v2/corporate/${corporateId}/detail/catalog/courses/add`),
      },
      {
        key: "path",
        icon: <Folders size={32} />,
        title: t("catalog.options.path.title"),
        description: t("catalog.options.path.description"),
        onSelect: () =>
          navigate(`/v2/corporate/${corporateId}/detail/catalog/paths/add`),
      },
    ],
  },
};
